import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Container,
  Dialog,
  Grid,
  TextField,
  IconButton,
  Tooltip,
  Popper,
  Paper,
} from "@material-ui/core";
import { CorreosButton } from "../../../components/CorreosButton/CorreosButton";
import { CheckCircle, CheckCircleOutline } from "@material-ui/icons";
import { CommonStyles } from "../../../commons/CommonStyles";
import { DialogStyles } from "../../CommonComponents/Dialogs/DialogStyles";
import { useTranslation } from "react-i18next";
import {
  DeleteVerificationUserEmail,
  PostVerificationDataEmail,
  PostVerificationDataEmailChange,
  PostVerificationSendEmail,
} from "../../../services/ReasonService";
import {
  checkIsNullUndefined,
  getErrorMessage,
  useOutsideAlerter,
} from "../../../commons/Utils";
import { RequiredDataStyles } from "../RequiredDataStyles";
import { EnumFirstSelectOption, generalWarning, iconNames } from "../../../commons/EnumsGeneral";
import { GeneralWarning } from "../../CommonComponents/GeneralWarning/GeneralWarning";
import { CorreosIcon } from "../../CommonComponents/CorreosIcon/CorreosIcon";

export function DialogEmailActions(props) {
  const {
    actualValue,
    emailsList,
    mandatory,
    mustRegistry,
    handleAddEmail,
    handleVerifyEmail,
    handleRemoveEmail,
    finishOperation,
    auxiliarTab,
  } = props;
  const commonClasses = CommonStyles();
  const dialogClasses = DialogStyles();
  const classes = RequiredDataStyles();
  const { t } = useTranslation();
  const wrapperRef = useRef(null);
  const validator = require("react-email-validator");

  const [open, setOpen] = useState(false);
  const [operationType, setOperationType] = useState("");
  const [hasValue, setHasValue] = useState(true);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [sendedOtp, setSendedOtp] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [emailErrorText, setEmailErrorText] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [otpErrorText, setOtpErrorText] = useState("");
  // const [toVerificate, setToVerificate] = useState(true);
  const [verificable, setVerificable] = useState(false);
  const [deletable, setDeletable] = useState(false);
  const [sendCircularProgress, setSendCircularProgress] = useState(false);
  const [actionCircularProgress, setActionCircularProgress] = useState(false);
  const [allOk, setAllOk] = useState(false);
  const [openWarnDialog, setOpenWarnDialog] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    let auxHasValue = true;
    let auxVerificable = true;
    let auxDeletable = true;
    let auxEmail = actualValue;
    if (checkIsNullUndefined(actualValue) || actualValue == EnumFirstSelectOption) {
      auxHasValue = false;
      auxVerificable = false;
      auxEmail = "";
    } else {
      let auxEmailObj = emailsList.find((email) => email.email == actualValue);
      if (!checkIsNullUndefined(auxEmailObj)) {
        auxDeletable = auxEmailObj.id != 0;
        auxVerificable = checkIsNullUndefined(auxEmailObj.idConTypeVerification) || auxEmailObj.idConTypeVerification < 2;
      };
    };
    setHasValue(auxHasValue);
    setVerificable(auxVerificable);
    setDeletable(auxDeletable);
    setEmail(auxEmail);
  }, [actualValue, emailsList]);

  useEffect(() => {
    let allOk = true;
    if ((operationType == "add" || operationType == "change") && (checkIsNullUndefined(email) || emailError)) {
      allOk = false;
    } else if (
      operationType != "delete" && (checkIsNullUndefined(otp) || !sendedOtp || otpError)
    ) {
      allOk = false;
    };
    setAllOk(allOk);
  }, [email, otp, operationType]);

  const handleOpen = (event, operationType) => {
    let auxEmail = checkIsNullUndefined(actualValue) ? "" : actualValue;
    if (operationType === "delete") {
      setAnchorEl(event.currentTarget);
    };
    if (operationType === "add" || operationType === "change") {
      auxEmail = "";
    };
    setOperationType(operationType);
    setEmail(auxEmail);
    setOpen(true);
  };

  const handleCancel = () => {
    setEmail("");
    setEmailError(false);
    setEmailErrorText("");
    // setToVerificate(false);
    setOperationType("");
    setAnchorEl(null);
    setAllOk(false);
    setActionCircularProgress(false);
    clearOtp();
    setOpen(false);
  };

  const clearOtp = () => {
    setOtp("");
    setOtpError(false);
    setOtpErrorText("");
    setSendedOtp(false);
    setSendCircularProgress(false);
  };

  const handleSetEmail = (value) => {
    let auxError = false;
    let auxErrorText = "";
    if (checkIsNullUndefined(value.target.value)) {
      auxError = true;
      auxErrorText = t("required");
    } else if (!validator.validate(value.target.value)) {
      auxError = true;
      auxErrorText = t("registerPageMailError");
    };
    setEmailError(auxError);
    setEmailErrorText(auxErrorText);
    clearOtp();
    setEmail(value.target.value);
  };

  const handleChangeOtp = (value) => {
    let auxError = false;
    let auxErrorText = "";
    if (checkIsNullUndefined(value.target.value)) {
      auxError = true;
      auxErrorText = t("required");
    };
    setOtpError(auxError);
    setOtpErrorText(auxErrorText);
    setOtp(value.target.value);
  };

  const handleSendOtp = () => {
    setSendCircularProgress(true);
    PostVerificationSendEmail(email).then((response) => {
      if (response && !response.Status) {
        setSendedOtp(true);
      } else {
        finishOperation("error", getErrorMessage(response, t));
      };
      setSendCircularProgress(false);
    });
  };

  const handleConfirmAction = () => {
    setActionCircularProgress(true);
    if (operationType == "delete") {
      handleDeleteable();
    } else {
      handleRepeatedEmail();
    };
  };

  const handleRepeatedEmail = () => {
    let auxRepeatedEmail = checkRepeatedEmail();
    if (!auxRepeatedEmail) {
      if (operationType == "add" || operationType == "verify") {
        handleVerificationDataEmail();
      } else {
        manageChangeEmail();
      };
    };
  };

  const handleDeleteable = () => {
    if (deletable) {
      handleDelete();
    } else {
      finishOperation("success", t("userDataDeleteEmailSuccess"));
      handleRemoveEmail(email);
      handleCancel();
    };
  };

  const handleDelete = async () => {
    try {
      // Verificar si es el último correo electrónico verificado
      if (checkEmailLastVerified()) {
        finishOperation("warning", t("verificationsDeleteLastEmail"));
        return setActionCircularProgress(false);
      };
      // Intentar eliminar el correo electrónico
      const response = await DeleteVerificationUserEmail(email);
      if (response && !response.Status) {
        finishOperation("success", t("userDataDeleteEmailSuccess"));
        handleRemoveEmail(email);
        handleCancel();
      } else {
        finishOperation("error", getErrorMessage(response, t));
      };
    } catch (error) {
      // Manejar errores inesperados
      finishOperation("error", t("genericError"));
    } finally {
      // Asegurarse de detener el progreso circular
      setActionCircularProgress(false);
    };
  };

  const checkEmailLastVerified = () => {
    // Filtrar correos electrónicos verificados
    const verifiedEmails = emailsList.filter((email) => email.idConTypeVerification >= 2);
    // Verificar si es el último correo electrónico verificado
    if (verifiedEmails.length === 1 && verifiedEmails[0].email === actualValue) {
      return true;
    };
    return false;
  };

  const handleVerificationDataEmail = () => {
    PostVerificationDataEmail(email, otp).then((response1) => {
      if (response1 && !response1.Status) {
        manageVerificationAction();
      } else {
        setOpenWarnDialog(true);
        setActionCircularProgress(false);
      };
    });
  };

  const manageChangeEmail = async () => {
    let response = await PostVerificationDataEmailChange(email, otp);
    if (response && !response.Status) {
      manageVerificationAction();
    } else {
      setOpenWarnDialog(true);
      setActionCircularProgress(false);
    };
  };

  const manageVerificationAction = () => {
    let auxText = "userDataVerifyEmailOk";
    let auxType = "success";
    if (operationType == "add") {
      handleAddEmail(email, true);
    } else if (operationType == "verify") {
      handleVerifyEmail(email);
    } else if (operationType == "change") {
      let oldEmail = emailsList[0];
      handleAddEmail(email, true, oldEmail.email);
    } else {
      auxText = "HUBO UN PROBLEMA";
      auxType = "error";
    };
    finishOperation(auxType, t(auxText));
    handleCancel();
  };

  const checkRepeatedEmail = () => {
    let repeated = false;
    let auxEmailList = emailsList.map((auxEmail) => auxEmail.email);
    let auxRepeatedEmailsList = auxEmailList.filter(
      (auxEmail) => auxEmail == email
    );
    if (operationType === "verify") {
      repeated = auxRepeatedEmailsList.length > 1;
    } else if (operationType === "add") {
      repeated = auxRepeatedEmailsList.length > 0;
    }
    if (repeated) {
      setEmailError(true);
      setEmailErrorText(t("verificationsEmailExists"));
      setActionCircularProgress(false);
    };
    return repeated;
  };

  useOutsideAlerter(wrapperRef, handleCancel);

  const addEmailBlock = () => {
    return (
      <Grid item xs={12}>
        <Tooltip title={t("add")}>
          <span>
            <CorreosButton
              color="primary"
              variant="contained"
              className={commonClasses.dialogButtonCenter}
              onClick={(event) => handleOpen(event, "add")}
            >
              <CorreosIcon iconSelected={iconNames.more} iconName="Add Icon" iconState={"basic"} iconScale={1.75} />
              {t("email")}
              {mandatory ? " *" : ""}
            </CorreosButton>
          </span>
        </Tooltip>
      </Grid>
    );
  };

  const changeEmailBlock = () => {
    return (
      <Grid item xs={4} className={classes.iconContainer}>
        <Tooltip title={t("CAMBIAR")}>
          <IconButton
            classes={{ root: classes.iconButton }}
            onClick={(event) => handleOpen(event, "change")}
            disabled={!hasValue}
          >
            <CorreosIcon iconSelected={iconNames.change} iconName="Change Icon" iconState={
              !hasValue
                ? "disabled"
                : "enabled"
            }
              iconScale={1.9} />
          </IconButton>
        </Tooltip>
      </Grid>
    );
  };

  const verifyEmailBlock = () => {
    return (
      <Grid item xs={4} className={classes.iconContainer}>
        <Tooltip title={t("verificationsVerify") + (mustRegistry ? " *" : "")}>
          <IconButton
            classes={{ root: classes.iconButton }}
            onClick={(event) => handleOpen(event, "verify")}
            disabled={!hasValue || !verificable}
          >
            {<CorreosIcon iconSelected={iconNames.verify} iconName="Verify Icon" iconState={
              !hasValue || !verificable
                ? "disabled"
                : "enabled"
            }
              iconScale={1.75} />}
            {mustRegistry ? " *" : ""}
          </IconButton>
        </Tooltip>
      </Grid>
    );
  };

  const deleteEmailBlock = () => {
    return (
      <Grid item xs={4} className={classes.iconContainer}>
        <Tooltip title={t("delete")}>
          <IconButton
            classes={{ root: classes.iconButton }}
            onClick={(event) => handleOpen(event, "delete")}
            disabled={!hasValue}
          >
            <CorreosIcon iconSelected={iconNames.delete} iconName="Delete Icon" iconState={
              !hasValue
                ? "disabled"
                : "enabled"
            }
              iconScale={1.75} />
          </IconButton>
        </Tooltip>
      </Grid>
    );
  };

  return (
    <Grid
      container
      item
      xs={12}
      spacing={1}
      className={classes.actionsComponentContainer}
    >
      {emailsList.length == 0 ? (
        addEmailBlock()
      ) : (
        <Grid
          container
          item
          xs={12}
          spacing={1}
          className={classes.iconsContainer}
        >
          {(auxiliarTab) && (addEmailBlock())}
          {verifyEmailBlock()}
          {emailsList.length > 1 ? deleteEmailBlock() : changeEmailBlock()}
          <Grid item xs={4} className={classes.iconContainer} />
        </Grid>
      )}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open && operationType !== "delete"}
        onClose={handleCancel}
        PaperProps={{ classes: { root: dialogClasses.dialogWindow } }}
      >
        <Container className={dialogClasses.dialogTitle}>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="h4"
                className={dialogClasses.dialogTitleText}
              >
                {operationType === "add"
                  ? t("userDataAddEmail")
                  : operationType === "verify"
                    ? t("userDataVerifyEmail")
                    : operationType === "change"
                      ? t("userDataModifyEmailTitle")
                      : ""}
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container className={dialogClasses.dialogContainer} style={{ paddingRight: "0.6em" }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                className={dialogClasses.dialogTitleText}
              >
                {operationType === "change" ? t("userDataModifyEmail") : t("userDataVerifyEmail")}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                className={commonClasses.inputsStyle}
                color="secondary"
                variant="filled"
                value={email}
                onChange={(value) => handleSetEmail(value)}
                fullWidth
                name="data"
                autoFocus
                label={t("UserEmail")}
                type="text"
                error={emailError}
                helperText={emailError ? emailErrorText : ""}
                disabled={operationType === "verify"}
                required
              />
            </Grid>
            <Grid item xs={12} sm={2} className={commonClasses.gridIdentity}>
              <CorreosButton
                variant={sendedOtp ? "text" : "contained"}
                color={sendedOtp ? "secondary" : "primary"}
                onClick={handleSendOtp}
                className={commonClasses.dialogButtonRight}
                disabled={emailError || checkIsNullUndefined(email)}
                circularProgress={sendCircularProgress}
              >
                {sendedOtp ? t("reSend") : t("send")}
              </CorreosButton>
            </Grid>
            {sendedOtp ? (
              <Grid item xs={12}>
                <TextField
                  color="secondary"
                  value={otp}
                  onChange={(value) => handleChangeOtp(value)}
                  variant="filled"
                  fullWidth
                  name="top"
                  label={t("lOtp")}
                  type="text"
                  error={otpError}
                  helperText={otpError ? otpErrorText : ""}
                  required
                  className={commonClasses.inputsStyle}
                />
              </Grid>
            ) : null}
            <Grid
              item
              container
              xs={12}
              className={dialogClasses.dialogButtonContainer}
            >
              <Grid item xs={6}>
                <CorreosButton
                  onClick={handleCancel}
                  className={dialogClasses.dialogButtonLeft}
                >
                  {t("cancel")}
                </CorreosButton>
              </Grid>
              <Grid item xs={6}>
                <CorreosButton
                  variant="contained"
                  color="primary"
                  onClick={handleConfirmAction}
                  className={dialogClasses.dialogButtonRight}
                  disabled={!allOk}
                  circularProgress={actionCircularProgress}
                >
                  {operationType == "add" ? t("add") : operationType == "verify" ? t("verificationsVerify") : operationType == "change" ? t("change") : ""}
                </CorreosButton>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Dialog>
      <Popper
        open={open && operationType === "delete"}
        anchorEl={anchorEl}
        placement={"top"}
        style={{ zIndex: 100 }}
        ref={wrapperRef}
      >
        <Paper>
          <Container>
            <Grid container style={{ paddingTop: "1em", paddingBottom: "1em" }}>
              <Grid item xs={12}>
                <Typography className={commonClasses.popperContentText}>
                  {t("userDataDeleteEmail")}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <CorreosButton
                  size="small"
                  onClick={handleCancel}
                  className={commonClasses.leftButton}
                >
                  {t("no")}
                </CorreosButton>
              </Grid>
              <Grid item xs={6}>
                <CorreosButton
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={handleConfirmAction}
                  className={commonClasses.rightButton}
                  circularProgress={actionCircularProgress}
                >
                  {t("yes")}
                </CorreosButton>
              </Grid>
            </Grid>
          </Container>
        </Paper>
      </Popper>
      <GeneralWarning open={openWarnDialog} setOpen={setOpenWarnDialog} isEmail={true} warnType={generalWarning.verify} />
    </Grid>
  );
}
